import React from 'react';
import { EllipsisContext } from './EllipsisContext';
import { EllipsisText } from './EllipsisText';
import { EllipsisTooltipWrapper } from './EllipsisTooltipWrapper';
export const Ellipsis = ({ maxTextLength, dataHook, text: fullText, position = 'top', ...textProps }) => {
    const [displayTruncatedText, setDisplayTruncatedText] = React.useState(fullText);
    const hasEllipsis = displayTruncatedText !== fullText;
    return (React.createElement(EllipsisContext.Provider, { value: { displayTruncatedText, setDisplayTruncatedText } },
        React.createElement("div", { "data-hook": dataHook, style: { display: 'contents' } },
            React.createElement(EllipsisTooltipWrapper, { fullText: fullText, hasEllipsis: hasEllipsis, position: position },
                React.createElement(EllipsisText, { text: fullText, ...textProps })))));
};
//# sourceMappingURL=Ellipsis.js.map